import { Tooltip } from '@mui/material';
import { STATUS_COLORS, TOOLTIP_COLORS } from '@/common/presentation/constants/colors';
import tid from '@/common/infrastructure/config/tid';

interface CertificationWarningIconProps {
  tooltipText?: string;
  /** When true, renders only the icon (for wrapping in an outer Tooltip). */
  disableTooltip?: boolean;
  testId?: string;
}

const WarningGlyph = ({ ariaLabel }: { ariaLabel: string }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="13"
    viewBox="0 0 13 13"
    fill="none"
    style={{ flexShrink: 0, cursor: 'default' }}
    aria-label={ariaLabel}
  >
    <path
      d="M6.3965 9.6C6.5655 9.6 6.70833 9.54283 6.825 9.4285C6.94167 9.31417 7 9.1725 7 9.0035C7 8.8345 6.94283 8.69167 6.8285 8.575C6.71417 8.45833 6.5725 8.4 6.4035 8.4C6.2345 8.4 6.09167 8.45717 5.975 8.5715C5.85833 8.68583 5.8 8.8275 5.8 8.9965C5.8 9.1655 5.85717 9.30833 5.9715 9.425C6.08583 9.54167 6.2275 9.6 6.3965 9.6ZM6.3965 7.2C6.5655 7.2 6.70833 7.1425 6.825 7.0275C6.94167 6.9125 7 6.77 7 6.6V3.8C7 3.63 6.94283 3.4875 6.8285 3.3725C6.71417 3.2575 6.5725 3.2 6.4035 3.2C6.2345 3.2 6.09167 3.2575 5.975 3.3725C5.85833 3.4875 5.8 3.63 5.8 3.8V6.6C5.8 6.77 5.85717 6.9125 5.9715 7.0275C6.08583 7.1425 6.2275 7.2 6.3965 7.2ZM6.40467 12.8C5.52378 12.8 4.69444 12.6333 3.91667 12.3C3.13889 11.9667 2.45833 11.5083 1.875 10.925C1.29167 10.3417 0.833333 9.66133 0.5 8.884C0.166667 8.10667 0 7.27611 0 6.39233C0 5.50856 0.166667 4.68056 0.5 3.90833C0.833333 3.13611 1.29167 2.45833 1.875 1.875C2.45833 1.29167 3.13867 0.833333 3.916 0.5C4.69333 0.166667 5.52389 0 6.40767 0C7.29144 0 8.11944 0.166667 8.89167 0.5C9.66389 0.833333 10.3417 1.29167 10.925 1.875C11.5083 2.45833 11.9667 3.13733 12.3 3.912C12.6333 4.68678 12.8 5.51456 12.8 6.39533C12.8 7.27622 12.6333 8.10556 12.3 8.88333C11.9667 9.66111 11.5083 10.3417 10.925 10.925C10.3417 11.5083 9.66267 11.9667 8.888 12.3C8.11322 12.6333 7.28544 12.8 6.40467 12.8Z"
      fill={STATUS_COLORS.WARNING_MAIN}
    />
  </svg>
);

export const CertificationWarningIcon = ({
  tooltipText = 'Certification(s) required',
  disableTooltip = false,
  testId
}: CertificationWarningIconProps) => {
  const glyph = <WarningGlyph ariaLabel={tooltipText} />;

  if (disableTooltip) {
    if (testId) {
      return <span {...tid(testId)}>{glyph}</span>;
    }
    return glyph;
  }

  return (
    <Tooltip
      title={tooltipText}
      arrow
      placement="top"
      slotProps={{
        popper: {
          sx: {
            '& .MuiTooltip-tooltip': {
              backgroundColor: TOOLTIP_COLORS.DARK_BACKGROUND,
              padding: '8px 12px',
              fontSize: '13px',
              '& .MuiTooltip-arrow': {
                color: TOOLTIP_COLORS.DARK_BACKGROUND
              }
            }
          }
        }
      }}
    >
      <span {...(testId ? tid(testId) : {})}>{glyph}</span>
    </Tooltip>
  );
};
